import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { ModelCard } from '../components/ModelCard';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Search } from 'lucide-react';
import { API } from '../lib/api';

export function SearchPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const { user } = useAuth();
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (query) {
      searchModels();
    } else {
      setLoading(false);
    }
  }, [query]);

  const searchModels = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/models?search=${encodeURIComponent(query)}`);
      setResults(res.data);
    } catch (error) {
      console.error('Search failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />

      <main data-testid="search-page" className="mt-16 pt-12 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-12"
          >
            <div className="flex items-center space-x-3 mb-2">
              <Search className="w-8 h-8 text-[#0066FF]" />
              <h1 className="text-4xl sm:text-5xl font-black text-white tracking-tight">Resultados da Busca</h1>
            </div>
            {query && (
              <p className="text-zinc-400">
                Mostrando resultados para <span className="text-white font-semibold">"{query}"</span>
              </p>
            )}
          </motion.div>

          {loading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="aspect-video bg-[#1A1A1A] rounded-lg animate-pulse" />
              ))}
            </div>
          ) : results.length === 0 ? (
            <div data-testid="no-results" className="text-center py-20">
              <Search className="w-20 h-20 text-zinc-700 mx-auto mb-4" />
              <h2 className="text-2xl font-bold text-white mb-2">Nenhum resultado encontrado</h2>
              <p className="text-zinc-400">Tente palavras-chave diferentes ou explore as categorias</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {results.map((model) => (
                <ModelCard key={model.id} model={model} isPremiumUser={user?.is_premium} />
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
